import {getField, updateField} from "vuex-map-fields";

const state = () => ({
    showConversationDialog: false,
    showBotPicker: false,
    showDialogBlockCustomer: false,
    showDialogChangeRequestSupport: false,
    showDialogCreateMADTemplate: false,
    showDialogImportAgentQuickResponse: false,
    dialogUpdateMADTemplate: {
        open: false,
        template: {}
    },
    showDialogMADTemplate: false,
    showDialogCreateQuickResponse: false,
    dialogConversationHistory: {},
});
const mutations = {
    toggleConversationDialog(state) {
        state.showConversationDialog = !state.showConversationDialog
    },
    toggleBotPicker(state) {
        state.showBotPicker = !state.showBotPicker
    },
    setDialogBlockCustomer(state, payload) {
        state.showDialogBlockCustomer = payload
    },
    setDialogChangeRequestSupport(state, payload) {
        state.showDialogChangeRequestSupport = payload
    },
    setDialogCreateQuickResponse(state, payload) {
        state.showDialogCreateQuickResponse = payload
    },
    setDialogImportAgentQuickResponse(state, payload) {
        state.showDialogImportAgentQuickResponse = payload
    },
    setDialogConversationHistory (state, payload) {
        state.dialogConversationHistory = payload
    },
    setDialogCreateMADTemplate (state, payload) {
        state.showDialogCreateMADTemplate = payload
    },
    setDialogUpdateMADTemplate (state, payload) {
        state.dialogUpdateMADTemplate = payload
    },
    setDialogMADTemplate(state, payload) {
        state.showDialogMADTemplate = payload
    },
    updateField
};
const actions = {
    openConversationHistoryBySession(context, {sessionId, user, updated, botCode, senderId, senderChannel}) {
        context.commit('toggleConversationDialog');
        context.commit('setDialogConversationHistory', {sessionId: sessionId, user: user, updated: updated, botCode: botCode, senderId: senderId, senderChannel: senderChannel})
    },
    openConversationHistoryByChatLog(context, chatLogs) {
        context.commit('toggleConversationDialog');
        context.commit('setDialogConversationHistory', {chatLogs: chatLogs})
    },
    openDialogBlockCustomer(context) {
        context.commit('setDialogBlockCustomer', true);
    },
    closeDialogBlockCustomer(context) {
        context.commit('setDialogBlockCustomer', false);
    },
    openDialogChangeRequestSupport(context) {
        context.commit('setDialogChangeRequestSupport', true);
    },
    closeDialogChangeRequestSupport(context) {
        context.commit('setDialogChangeRequestSupport', false);
    },
    openDialogMADTemplate(context) {
      context.commit('setDialogMADTemplate', true)
    },
    closeDialogMADTemplate(context) {
      context.commit('setDialogMADTemplate', false)
    },
    openDialogCreateMADTemplate(context) {
        context.commit('setDialogCreateMADTemplate', true);
    },
    closeDialogCreateMADTemplate(context) {
        context.commit('setDialogCreateMADTemplate', false);
    },
    openDialogUpdateMADTemplate(context, data) {
        context.commit('setDialogUpdateMADTemplate', {open: true, template: data});
    },
    closeDialogUpdateMADTemplate(context) {
        context.commit('setDialogUpdateMADTemplate', {open: false, template: {}});
    },
    openDialogCreateQuickResponse(context) {
        context.commit("setDialogCreateQuickResponse", true);
    },
    openDialogCreateQuickResponseLeader(context) {
        context.commit("setDialogCreateQuickResponse", true);
        context.commit("agentQuickResponse/setType", 1, {root: true});
    },
    openDialogImportAgentQuickResponse(context) {
        context.commit("setDialogImportAgentQuickResponse", true);
        context.commit("agentQuickResponse/setType", 0, {root: true});
    },
    openDialogImportAgentQuickResponseLeader(context) {
        context.commit("setDialogImportAgentQuickResponse", true);
        context.commit("agentQuickResponse/setType", 1, {root: true});
    },
    openDialogUpdateQuickResponse({ commit, dispatch }, data) {
        dispatch('agentQuickResponse/bindUpdateForm', data, { root: true })
        commit("setDialogCreateQuickResponse", true)
    },
    closeDialogImportAgentQuickResponse(context) {
        context.commit("setDialogImportAgentQuickResponse", false);
    },
    closeDialogCreateQuickResponse(context) {
        context.commit("setDialogCreateQuickResponse", false);
        context.commit("agentQuickResponse/setType", 0, {root: true});
    }

};
const getters = {getField};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
